import _kebabCase from "lodash/kebabCase";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = ["innerHTML"];
import highlight from 'highlight.js';
import 'highlight.js/styles/androidstudio.css';
import { previewCode } from '../../api/code-gen';
import { useCommonDialog } from '@/component-create/utils/hooks';

import { ref, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Preview',
  setup(__props, {
    expose: __expose
  }) {
    const dialogRef = useCommonDialog('dialogRef');
    const tab = ref({
      active: 'entity',
      loading: false
    });
    const preview = ref({
      businessName: '',
      entity: '',
      mapper: '',
      mapperXml: '',
      service: '',
      serviceImpl: '',
      controller: '',
      importHandler: '',
      api: '',
      managerView: '',
      createView: '',
      updateView: '',
      ieo: '',
      viewConfig: ''
    });
    const entityCode = computed(() => highlight.highlight('java', preview.value.entity).value);
    const mapperCode = computed(() => highlight.highlight('java', preview.value.mapper).value);
    const mapperXmlCode = computed(() => highlight.highlight('xml', preview.value.mapperXml).value);
    const serviceCode = computed(() => highlight.highlight('java', preview.value.service).value);
    const serviceImplCode = computed(() => highlight.highlight('java', preview.value.serviceImpl).value);
    const controllerCode = computed(() => highlight.highlight('java', preview.value.controller).value);
    const ieoCode = computed(() => highlight.highlight('java', preview.value.ieo).value);
    const importHandlerCode = computed(() => highlight.highlight('java', preview.value.importHandler).value);
    const api = computed(() => highlight.highlight('java', preview.value.api).value);
    const managerView = computed(() => highlight.highlight('java', preview.value.managerView).value);
    const createView = computed(() => highlight.highlight('java', preview.value.createView).value);
    const updateView = computed(() => highlight.highlight('java', preview.value.updateView).value);
    const viewConfig = computed(() => highlight.highlight('java', preview.value.viewConfig).value);
    function show(biz) {
      tab.value.active = 'entity';
      dialogRef.open();
      load(biz);
    }
    function load(biz) {
      tab.value.loading = true;
      previewCode(biz).then(result => {
        preview.value = result.data;
      }).catch(() => {
        tab.value.loading = false;
        close();
      }).finally(() => {
        tab.value.loading = false;
      });
    }
    function close() {
      if (tab.value.loading) {
        return;
      }
      dialogRef.close();
    }
    function kebab(str) {
      return _kebabCase(str);
    }
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_x_common_dialog = _resolveComponent("x-common-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_x_common_dialog, {
        ref_key: "dialogRef",
        ref: dialogRef,
        title: "代码预览",
        width: "80%"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_tabs, {
          modelValue: _unref(tab).active,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(tab).active = $event)
        }, {
          default: _withCtx(() => [_unref(preview).entity ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 0,
            label: `${_unref(preview).businessName}.java`,
            name: "entity"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "code-block",
              contenteditable: "true",
              innerHTML: _unref(entityCode)
            }, null, 8, _hoisted_1)]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).controller ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 1,
            label: `${_unref(preview).businessName}Controller.java`,
            name: "controller"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "code-block",
              contenteditable: "true",
              innerHTML: _unref(controllerCode)
            }, null, 8, _hoisted_2)]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).service ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 2,
            label: `${_unref(preview).businessName}Service.java`,
            name: "service"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "code-block",
              contenteditable: "true",
              innerHTML: _unref(serviceCode)
            }, null, 8, _hoisted_3)]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).serviceImpl ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 3,
            label: `${_unref(preview).businessName}ServiceImpl.java`,
            name: "serviceImpl"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "code-block",
              contenteditable: "true",
              innerHTML: _unref(serviceImplCode)
            }, null, 8, _hoisted_4)]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).mapper ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 4,
            label: `${_unref(preview).businessName}Mapper.java`,
            name: "mapper"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "code-block",
              contenteditable: "true",
              innerHTML: _unref(mapperCode)
            }, null, 8, _hoisted_5)]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).mapperXml ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 5,
            label: `${_unref(preview).businessName}Mapper.xml`,
            name: "mapperXml"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "code-block",
              contenteditable: "true",
              innerHTML: _unref(mapperXmlCode)
            }, null, 8, _hoisted_6)]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).ieo ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 6,
            label: `${_unref(preview).businessName}IEO.java`,
            name: "ieo"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "code-block",
              contenteditable: "true",
              innerHTML: _unref(ieoCode)
            }, null, 8, _hoisted_7)]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).importHandler ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 7,
            label: `${_unref(preview).businessName}ImportHandler.java`,
            name: "importHandler"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "code-block",
              contenteditable: "true",
              innerHTML: _unref(importHandlerCode)
            }, null, 8, _hoisted_8)]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).api ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 8,
            label: `${kebab(_unref(preview).businessName)}.ts`,
            name: "api"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "code-block",
              contenteditable: "true",
              innerHTML: _unref(api)
            }, null, 8, _hoisted_9)]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).managerView ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 9,
            label: _unref(preview).businessName + '.vue',
            name: "manager"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "code-block",
              contenteditable: "true",
              innerHTML: _unref(managerView)
            }, null, 8, _hoisted_10)]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _unref(preview).viewConfig ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 10,
            label: "config.ts",
            name: "viewConfig"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "code-block",
              contenteditable: "true",
              innerHTML: _unref(viewConfig)
            }, null, 8, _hoisted_11)]),
            _: 1
          })) : _createCommentVNode("", true), _unref(preview).createView ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 11,
            label: "create.vue",
            name: "create"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "code-block",
              contenteditable: "true",
              innerHTML: _unref(createView)
            }, null, 8, _hoisted_12)]),
            _: 1
          })) : _createCommentVNode("", true), _unref(preview).updateView ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 12,
            label: "update.vue",
            name: "update"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "code-block",
              contenteditable: "true",
              innerHTML: _unref(updateView)
            }, null, 8, _hoisted_13)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"])), [[_directive_loading, _unref(tab).loading]])]),
        _: 1
      }, 512);
    };
  }
});